import { render, staticRenderFns } from "./SpecialInventoryPhysicalR.vue?vue&type=template&id=2d8963c0&scoped=true"
import script from "./SpecialInventoryPhysicalR.vue?vue&type=script&lang=js"
export * from "./SpecialInventoryPhysicalR.vue?vue&type=script&lang=js"
import style0 from "./SpecialInventoryPhysicalR.vue?vue&type=style&index=0&id=2d8963c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8963c0",
  null
  
)

export default component.exports